import * as React from 'react'
import * as styles from './Fallback.module.scss'
import * as cn from 'classnames'
import { withArgs, Args, RequestContext } from '@utils'

interface FallbackProps {
  customerMessage?: string
}


const LastResortStrings: { [lang: string]: string[] } = {
  //From string ID DV_WEB_STOREFRONT_STATIC_ERROR
  'en-US': ['This page is temporarily unavailable.', 'We apologize for the inconvenience and ask that you try again later.'],
  'en-GB': ['This page is temporarily unavailable.', 'We apologise for the inconvenience and ask that you try again later.'],
  'fr': ['Cette page est temporairement indisponible.', 'Nous vous prions de nous excuser pour la gêne occasionnée. Merci de réessayer ultérieurement.'],
  'ja': ['このページは一時的にご利用いただけません。', 'ご不便をおかけして申し訳ありません。後でもう一度お試しください。'],
  'de': ['Diese Seite ist vorübergehend nicht verfügbar.', 'Wir bitten um Entschuldigung für die Unannehmlichkeiten. Bitte versuchen Sie es später erneut.'],
  'es': ['Esta página no está disponible temporalmente.', 'Disculpa por el inconveniente, vuelve a intentarlo más tarde.']
}

const selectBestLocale = (context: RequestContext) => {

  const requestLocale = context.locale
  const marketplace = context.marketplaceID

  // This is the only one where the variant is distinguished
  if (requestLocale === 'en_GB')
    return 'en-GB'

  const language = requestLocale.split('_')[0]
  if (LastResortStrings[language])
    return language

  // If this is a retail marketplace use the default locale
  // if we didn't find the preferred locale above
  if (marketplace === 'A1F83G8C2ARO7P')
    return 'en-GB'
  if (marketplace === 'ATVPDKIKX0DER')
    return 'en-US'
  if (marketplace === 'A1PA6795UKMFR9')
    return 'de'
  if (marketplace === 'A1VC38T7YXB528')
    return 'ja'

  return 'en-US'
}

// This message should only be displayed if WPS is down
const partiallyLocalisedGenericMessage = (props: Args) => {
  const locale = selectBestLocale(props.context)
  const strings = LastResortStrings[locale]
  return <div>
    <p>{strings[0] || ''}</p>
    <p>{strings[1] || ''}</p>
  </div>
}

const PartiallyLocalisedGenericMessage = withArgs(partiallyLocalisedGenericMessage) as React.ComponentType;


const Fallback = ({ customerMessage }: FallbackProps) => (
  <div className={cn('tst-fallback', styles.Fallback)}>
    {customerMessage ? (<p>{customerMessage}</p>) : (<PartiallyLocalisedGenericMessage />)}
  </div>
)

export default Fallback
